import {IRealmAuth} from "@nic-react/ability";


export enum Actions {
    MANAGE = 'manage',
    CREATE = 'create',
    VIEW = 'view',
    READ = 'read',
    UPDATE =  'update',
    DELETE = 'delete'
}

export enum Subjects {
    REQUESTS = 'requests',
    REQUEST = 'request',
    BOOKING = 'booking',
    BOOKINGS = 'bookings',
    DASHBOARD = 'dashboard',
    CALENDAR = 'calendar',
    REGISTRAR_INFO = 'registrarInfo',
    TESTS = 'tests',
    TEST = 'test',
    CONTACT = 'contact',
    IP = 'ip'
}
interface IAuthDef {
    actions: string[];
    subject: string;
}
const BasicRestriction: Array<IAuthDef> =  [
    {
        actions: [Actions.VIEW, Actions.READ], subject: Subjects.BOOKINGS
    },
    {
        actions: [Actions.VIEW, Actions.READ], subject: Subjects.REQUESTS
    },
    {
        actions: [Actions.VIEW, Actions.READ], subject: Subjects.REQUEST
    }
]


export const AppRestrictions: IRealmAuth = {
    registry: {
        roles: {
            tech: [
                {
                    subject: Subjects.DASHBOARD,
                    actions: [Actions.VIEW, Actions.READ]
                },
                {
                    subject: Subjects.CALENDAR,
                    actions: [Actions.VIEW, Actions.READ]
                },
                {
                    subject: Subjects.BOOKING,
                    actions: [Actions.VIEW]
                },
                {
                    subject: Subjects.REGISTRAR_INFO,
                    actions: [Actions.VIEW]
                },
                {
                    actions: [Actions.VIEW, Actions.READ], subject: Subjects.TEST
                },
                {
                    actions: [Actions.VIEW, Actions.READ], subject: Subjects.TESTS
                },
                {
                    actions: [Actions.VIEW, Actions.READ], subject: Subjects.CONTACT
                },
                {
                    actions: [Actions.VIEW, Actions.READ], subject: Subjects.IP
                },
                ...BasicRestriction
            ],
            'tech-admin': [
                {
                    actions: [Actions.VIEW, Actions.READ, Actions.DELETE, Actions.UPDATE], subject: Subjects.BOOKING
                },
                {
                    actions: [Actions.VIEW, Actions.READ, Actions.UPDATE], subject: Subjects.CONTACT
                },
                {
                    actions: [Actions.VIEW, Actions.READ, Actions.UPDATE], subject: Subjects.IP
                },
                ...BasicRestriction
            ],
            'user': [
                ...BasicRestriction
            ],
            'billing': [...BasicRestriction],
            'billing-admin': [...BasicRestriction],
            'operator': [...BasicRestriction],
            'operator-admin': [...BasicRestriction],
            'legal': [...BasicRestriction],
            'legal-admin': [...BasicRestriction],
            'domain': [...BasicRestriction],
            'domain-admin': [...BasicRestriction]
        },

    },
    registrar: {
        roles: {
            admin: [
                {
                    subject: Subjects.BOOKINGS,
                    actions: [Actions.READ]
                },
                {
                    subject: Subjects.REQUESTS,
                    actions: [Actions.READ, Actions.VIEW]
                },

                {
                    subject: Subjects.REQUEST,
                    actions: [Actions.READ, Actions.VIEW]
                },

                {
                    subject: Subjects.BOOKING,
                    actions: [Actions.VIEW, Actions.DELETE, Actions.UPDATE]
                },
                {
                    subject: Subjects.REGISTRAR_INFO,
                    actions: [Actions.VIEW]
                },

                {
                    subject: Subjects.TEST,
                    actions: [Actions.VIEW, Actions.READ]
                },
                {
                    subject: Subjects.TESTS,
                    actions: [Actions.VIEW, Actions.READ]
                },
                {
                    subject: Subjects.CONTACT,
                    actions: [Actions.VIEW, Actions.READ, Actions.UPDATE],
                },
                {
                    subject: Subjects.IP,
                    actions: [Actions.VIEW, Actions.READ, Actions.UPDATE]
                },

            ],
        }
    }
}